import React from "react";
import ReactPlayer from "react-player/lazy";

const Video = ({ url }) => {
  const isSwitchTube = url?.includes("tube.switch.ch");

  return (
    <div className="oHomeVideo">
      {!isSwitchTube && (
        <div className="oHomeVideo_wrapper">
          <ReactPlayer
            className="oHomeVideo_player"
            url={url}
            volume={0}
            width="100%"
            height="100%"
            loop
            muted
            playing
          />
          <div className="oHomeVideo_overlay" />
        </div>
      )}
      {isSwitchTube && (
        <video loop muted autoPlay src={url} style={{ width: "100%" }} />
      )}
    </div>
  );
};

export default Video;
